import { createFileRoute } from '@tanstack/react-router';
import { HostEvent } from '@thoughtspot/visual-embed-sdk/react';
import { useCallback, useContext, useEffect, useRef } from 'react';
import { getOffset, PrerenderedAppEmbedContext } from '@/components/Thoughtspot/PreRenderedAppEmbed';

export const Route = createFileRoute('/dashboard/_thoughtspot/schedules')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    reload: search.reload ? (search.reload as number) : undefined,
  }),
});

/**
 * Used to display pages from the ai highlights section of the dashboard.
 * /dashboard/ai-highlights/home/liveboard-schedules
 */
function RouteComponent() {
  const { reload } = Route.useSearch();
  const ref = useRef<HTMLDivElement | null>(null);
  const { initializeView, embedRef } = useContext(PrerenderedAppEmbedContext);

  const handleReload = useCallback(async () => {
    try {
      await embedRef.current?.trigger(HostEvent.Reload);
    } catch (error) {
      console.error('Failed to reload:', error);
    }
  }, [embedRef]);

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const targetPath = 'insights/home/liveboard-schedules';
    const coords = ref.current.getBoundingClientRect();
    const offset = getOffset(ref.current);
    const coordsData = {
      height: coords.height,
      width: coords.width,
      top: offset.top,
      left: offset.left,
    };

    initializeView(targetPath, coordsData);

    // Trigger reload if specified in URL params
    if (reload) {
      void handleReload();
    }
  }, [reload, handleReload, initializeView]);

  return <div ref={ref}></div>;
}
